export default function SantaTracker() {
	return (
		<div>
			<center>
				<iframe
					src="https://scratch.mit.edu/projects/1246754519/embed"
					allowtransparency="true"
					width="485"
					height="402"
					frameborder="0"
					allowfullscreen
				/>
			</center>
		</div>
	);
}
